/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * **EXPERIMENTAL** - This icon is still under development, and may change visually.
 *
 *![ExperimentalConfettiIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACRUlEQVR4nN1VzYuNYRR/RiGi2IiFpJSksGQzwubO3Pd8PJPnPedeNEO6pcl/oO5KKdmMjJ2tYiuJhfJRFsSClMIKO5mmfEy+Ou+Hee+973uvaWbDqbs57+93znM+fuc6919axDICpLOIergKgxi2I+sbIL0QQlhhvnq9uR4gbB2YgEiayPoLWJ4OwqQ4fYEkt4H0G5B+J5LNfRMg4log/Wzk0RA2llZJcixP0PEj+WL8ileNrwOWW8j6MydE3NjXjfP+6AZgfVieQG9Wvtz6mZRM8uNP+T7e24EB3Qkk70uDpxW8CiGsqkggN7KeXimQzvxVazqrmK5oUeNkCfhZNw4xPoAsl2yoFVW8dv22A0ivIuvZrF1z7XZ7Wf7dhg4klwF0F7JMFYLeB9YYvYTRseYWN8hqtdrKnNxqtZYjxsPAehdY32b+c+bLqvxgg3cLNdMBsDyytUOWj/N7L+8AwrYUow1m2eEWYxHJoeylD+o+3m3V9VH3+YEBEdUj6RNgvYdeJ6MoWo2sbaLmnlI86TSSXgPST6bk4sx6wawnTAfZhnzNWnLdOTdk340MJBPAMpZzgPVOcYsqW5YHz9px0fsjm3IysJxKgpGenhehHjSf3Z6uNX1Z2ueigpFlxgZp58Pui52G5BFeJwtnZL/5Qghr8lVFjI8DS9STAFge94pGZlJByZwNOIMOoY8VvdY7+F5rVcNPSXYFK6QPVllXwAUbsjyvCg4kE26xlsi8LDjruFsqs7/IRL2ks8m9x3h4yYL/s/YbRQGQCaCYyYgAAAAASUVORK5CYII=)
 */
export const ExperimentalConfettiIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="m17.58 11.07 1-1.37a1 1 0 0 1 .78-.4h1.68a1 1 0 0 0 .77-1.52l-1-1.35a1 1 0 0 1-.14-.87L21.18 4a1 1 0 0 0-1.2-1.21l-1.6.55a1 1 0 0 1-.86-.14l-1.35-1a1 1 0 0 0-1.52.8v1.69a1 1 0 0 1-.4.78l-1.38 1a1 1 0 0 0 .27 1.68l1.6.5a1 1 0 0 1 .63.63l.5 1.6a1 1 0 0 0 1.7.2ZM7 13.1a2.28 2.28 0 0 0-1.63.65L3 16.12A3.44 3.44 0 0 0 7.86 21l2.37-2.36c1.06-1.06.8-2.86-.61-4.27a3.87 3.87 0 0 0-2.63-1.26Zm1.99 4.26c-.32.32-1.1.05-1.75-.6-.65-.65-.92-1.43-.6-1.75.32-.32 1.1 0 1.75.6.65.6.9 1.43.6 1.75ZM13.98 14.5a1.49 1.49 0 1 0 .08 2.97 1.49 1.49 0 0 0-.08-2.97ZM8.2 6.84a7.12 7.12 0 0 0-.79-4.29 1 1 0 1 0-1.79.9c.25.49.43 1.01.54 1.55a2.26 2.26 0 0 0-1 0 2.39 2.39 0 0 0-1.4 3.8 2.37 2.37 0 0 0 3.16.5c.1.53.12 1.07.07 1.61a1 1 0 0 0 2 .23 7.15 7.15 0 0 0-.79-4.3Zm-2.59.84a.36.36 0 0 1-.36-.37.37.37 0 0 1 .36-.37.38.38 0 0 1 .38.37.37.37 0 0 1-.38.37Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M13.77 11.83a2 2 0 0 0 .82-1.32 1.01 1.01 0 1 0-2-.3.55.55 0 0 1-.26 0 2 2 0 0 0-1.64.34 2.94 2.94 0 0 0-1 1.91 1 1 0 0 0 1.99.24c0-.23.15-.5.3-.54a2.22 2.22 0 0 0 1.8-.33ZM21.31 14.81a1.39 1.39 0 0 1-.34-1.08l.06-.67a.66.66 0 0 0-1.12-.53l-.47.47a1.38 1.38 0 0 1-1.08.37l-.67-.06a.66.66 0 0 0-.53 1.12l.47.5a1.36 1.36 0 0 1 .35 1.06l-.06.68a.66.66 0 0 0 1.12.53l.49-.47a1.37 1.37 0 0 1 1.06-.38l.68.06a.66.66 0 0 0 .53-1.12l-.49-.48Z"
        className={colorClass}
      />
    </svg>
  );
};
